// extracted by mini-css-extract-plugin
export default {"questionLabel":"style__questionLabel___lPHl7","bar":"style__bar___fALXV","barPercentageLabel":"style__barPercentageLabel___z6G87","answerLabel":"style__answerLabel___kQKOg"};